import { FileReference } from '@kaizenplatform/belfast-entity';
import { FileIdsValue, SelectMultipleValue } from '@kaizenplatform/hugot-entity';
import { Meta } from '@kaizenplatform/hugot-entity/dist/entity/DynamicSchemaDefinition/IDynamicSchemaSection';
import { createElement } from 'react';

import { DynamicSchemaDefinitionField } from '../../../../../generated/graphql';
import AsFileIds from './AsFileIds';
import AsMultiLineText from './AsMultiLineText';
import AsSelectOne from './AsSelectOne';
import AsSingleLineText from './AsSingleLineText';

interface Props {
  field: Pick<DynamicSchemaDefinitionField, 'type' | 'key'>;
  value: Map<string, string | number | boolean | SelectMultipleValue | FileIdsValue | null>;
  beforeValue?: Map<string, string | number | boolean | SelectMultipleValue | FileIdsValue | null>;
  files: ReadonlyArray<FileReference>;
  meta?: Meta;
  className?: string;
}

const Field = ({ field, value, beforeValue, files, meta }: Props) => {
  if (field.type === 'SELECT_ONE' && meta != null && meta.isAllowLeaveToTheCreators) {
    return <AsSelectOne field={field} value={value} beforeValue={beforeValue} />;
  }

  if (field.type === 'SINGLE_LINE_TEXT') {
    return <AsSingleLineText field={field} value={value} beforeValue={beforeValue} />;
  }

  if (field.type === 'MULTI_LINE_TEXT') {
    return <AsMultiLineText field={field} value={value} beforeValue={beforeValue} />;
  }

  if (field.type === 'FILE_IDS') {
    return <AsFileIds field={field} value={value} files={files} />;
  }

  return null;
};

export default Field;
